// extracted by mini-css-extract-plugin
module.exports = {"preview":"J07RMMop8NgDhmEsIPoUnA==","previewBox":"pgzlDYYR798sxs0icwgiUg=="};